// extracted by mini-css-extract-plugin
export default {"root":"EditLiveRoomTeamPanel_root__YQT9D","form":"EditLiveRoomTeamPanel_form__WrWSG","listingLink":"EditLiveRoomTeamPanel_listingLink__XOF3p"};